import { Link, graphql } from "gatsby"
import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import Layout from "../components/layout"
import Seo from "../components/seo"
import { LazyLoadComponent } from "react-lazy-load-image-component"
import { getImage } from "gatsby-plugin-image"
import { StaticImage } from "gatsby-plugin-image"
import { convertToBgImage } from "gbimage-bridge"

import styled from "styled-components"
import "./case-study.css"
import Sticky from "react-sticky-el"

const BgImage = styled.div`
  position: relative;
  &::before {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    transition: opacity 0.5s ease 250ms;
    background-image: url(${props => props.background});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-repeat-x: no-repeat;
    background-repeat-y: no-repeat;
  }
`

class CaseStudies extends React.Component {
  constructor() {
    super()
    this.state = {
      categories: "All",
      class: "",
    }
    this.handleClick = this.handleClick.bind(this)
  }
  handleClick(event) {
    event.preventDefault()
    this.setState({ categories: event.target.value, class: "animated fadeIn" })
  }

  render() {
    const { data } = this.props
    const siteTitle = "sitetitle"
    const filterCStud = data.allSanityCaseStudy.group.filter(
      fltr => fltr.fieldValue === this.state.categories
    )

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <Seo
          title="Case Studies | Quandary Consulting Group"
          description="See how we've helped clients rethink operations with innovation, AI, and rapid application development that scales operations without adding back-office costs."
        />

        <div className="relative">
          <div className="hero-banner relative pt-4 overflow-hidden">
            <div className="hero-overlay relative">
              <StaticImage
                placeholder="none"
                className="wave-img"
                src="https://cdn.sanity.io/images/55lcecww/production/5ef5b5149a6edf0ad2c67cbe3874446d1cee06e2-904x650.png"
                alt="System Integration"
                layout="constrained"
                style={{ height: "fit-content", zIndex: 0 }}
                fetchpriority="low"
              />
            </div>
            <div className="container relative my-auto" style={{ zIndex: 1 }}>
              <div className="row pb-3 align-items-center">
                <div className="col-lg-7 col-xl-7 col-md-7">
                  <div className="hero-custom-content-home review-content text-white">
                    <h1
                      className="page-title text-left"
                      style={{
                        marginBottom: "0.5rem",
                        display: "inline",
                      }}
                    >
                      {/* {item?.title} */}
                      We help businesses turn ideas into innovative solutions
                      that reimagine how work gets done.
                    </h1>

                    <div className="hero-button">
                      <Link
                        to="/case-studies/#case-studies-item"
                        className="btn btn-primary btn-arrow mr-2 mt-4 text-center text-capitalize py-3"
                        style={{ marginTop: "auto" }}
                      >
                        Our Best Work
                      </Link>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-5 col-md-5 pb-2 mb-5 mb-md-0 d-flex justify-content-end"
                  style={{ position: "relative" }}
                >
                  <StaticImage
                    placeholder="none"
                    className="rounded d-flex w-100"
                    src="https://cdn.sanity.io/images/55lcecww/production/80973b69cba8b138977e0105e9b290778995c918-1800x1800.png"
                    alt="Case Study"
                    layout="constrained"
                    style={{ height: "fit-content", zIndex: 1 }}
                    fetchpriority="low"
                  />
                </div>
              </div>
            </div>
          </div>

          <Container
            id="case-studies-item"
            className="case-cat overflow-hidden"
          >
            {/* <Sticky>
              <ul className="style-unstyled cat-nav p-0 text-center text-left-mobile categories-wrapper">
                <li className="d-inline">
                  <button value="All" onClick={this.handleClick}>
                    All
                  </button>
                </li>
                {data.allSanityCaseStudy.group.map(tag => (
                  <li className="d-inline" key={tag.fieldValue}>
                    <button value={tag.fieldValue} onClick={this.handleClick}>
                      {tag.fieldValue}
                    </button>
                  </li>
                ))}
              </ul>
            </Sticky> */}
            <div className="row">
              {data.allSanityCaseStudy.edges
                .slice(0, 7)
                .map(({ node: caseStudy }) => {
                  const logoImage = getImage(
                    caseStudy.logoImage?.asset?.gatsbyImageData ||
                      "https://source.unsplash.com/collection/2203755"
                  )
                  return (
                    <div
                      className="col-12 studies-item px-5"
                      key={caseStudy.id}
                    >
                      <div className="row">
                        <div className="col-md-5 mb-5 mb-md-0">
                          <div className="relative">
                            <h3 className="mb-4 mt-0">{caseStudy.title}</h3>
                            {logoImage ? (
                              <img
                                src={
                                  logoImage.images?.fallback?.src || logoImage
                                }
                                className="img-fluid rounded mb-2"
                                alt={caseStudy.title}
                                style={{ width: "220px" }}
                              />
                            ) : (
                              <img
                                src="https://source.unsplash.com/collection/2203755"
                                className="img-fluid rounded"
                                alt="Logo"
                                style={{ width: "220px" }}
                              />
                            )}
                          </div>
                        </div>
                        <div className="col-md-7">
                          <div className="relative challenge-wrapper mb-4">
                            <h4>Challenge</h4>
                            <p>{caseStudy.challenge}</p>
                          </div>
                          <div className="relative solution-wrapper mb-4">
                            <h4>Solution</h4>
                            <p>{caseStudy.solution}</p>
                          </div>
                          <Link
                            className="btn btn-primary btn-arrow"
                            to={`/case-study/${caseStudy.slug.current}/`}
                          >
                            See Case Study
                          </Link>
                        </div>
                      </div>
                    </div>
                  )
                })}
            </div>
          </Container>
          <section
            className="relative"
            style={{
              paddingTop: "5rem",
              paddingBottom: "5rem",
              backgroundColor: "#f5f5f5",
            }}
          >
            <Container>
              <div>
                <h2 className="text-center">More Case Studies</h2>
                <Row className="justify-content-start mt-5">
                  {this.state.categories === "All"
                    ? data.allSanityCaseStudy.edges.slice(7).map(stdy => {
                        return (
                          <Col
                            md={6}
                            lg={4}
                            key={stdy.node.id}
                            className="p-relative mb-4"
                          >
                            <div
                              className={`position-relative case-studies-wrapper ${this.state.class}`}
                              style={{
                                borderRadius: "5px",
                                height: "370px",
                                backgroundImage: `url("https://cdn.sanity.io/images/55lcecww/production/18b972bd27e8ed73c5e2e6e3062e23003eb68b77-800x800.jpg")`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                              }}
                            >
                              {/* <StaticImage
                                placeholder="none"
                                className="wave-img"
                                src="https://cdn.sanity.io/images/55lcecww/production/18b972bd27e8ed73c5e2e6e3062e23003eb68b77-800x800.jpg"
                                alt={stdy.node.title}
                                layout="constrained"
                                style={{ height: "fit-content", zIndex: 0 }}
                                fetchpriority="low"
                              /> */}
                              <div
                                className="c-stud"
                                style={{ position: "relative", zIndex: 2 }}
                              >
                                <Link
                                  to={`/case-study/${stdy.node.slug.current}/`}
                                >
                                  <p className="h5 text-white font-weight-bold">
                                    {stdy.node.title.length > 70
                                      ? `${stdy.node.title.substring(0, 70)}...`
                                      : stdy.node.title}
                                  </p>
                                </Link>
                              </div>
                            </div>
                          </Col>
                        )
                      })
                    : filterCStud[0].edges.map(stud => {
                        const StdImg = getImage(
                          stud.node.mainImage !== null
                            ? stud.node.mainImage.asset.gatsbyImageData
                            : "https://source.unsplash.com/collection/2203755"
                        )
                        const StdBgImg = convertToBgImage(StdImg)

                        return (
                          <Col
                            md={4}
                            key={stud.node.id}
                            className="p-relative mb-4"
                          >
                            {/* {console.log("stud", stud)} */}
                            <div
                              className={`position-relative case-studies-wrapper ${this.state.class}`}
                              style={{ borderRadius: "5px", height: "370px" }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                  backgroundColor: "#00293a",
                                  opacity: 0.8,
                                  borderRadius: "5px",
                                  zIndex: 1,
                                }}
                              ></div>
                              <StaticImage
                                placeholder="none"
                                className="wave-img"
                                src="./img/wave-white-right.png"
                                alt={stud.node.title}
                                layout="constrained"
                                style={{ height: "fit-content", zIndex: 0 }}
                                fetchpriority="low"
                              />
                              <div
                                className="c-stud"
                                style={{ position: "relative", zIndex: 2 }}
                              >
                                <Link
                                  to={`/case-study/${stud.node.slug.current}/`}
                                >
                                  <ul
                                    className="list-unstyled"
                                    style={{ height: "7rem" }}
                                  >
                                    {stud.node.categories.length !== 0
                                      ? stud.node.categories.map(cat => (
                                          <li
                                            className="text-white"
                                            key={cat.title}
                                          >
                                            {cat.title}
                                            <span>, </span>
                                          </li>
                                        ))
                                      : null}
                                  </ul>
                                  <h4 className="text-white font-weight-bold">
                                    {stud.node.title}
                                  </h4>
                                  <div className="std-cat">
                                    <ul
                                      className="list-unstyled"
                                      style={{ height: "7rem" }}
                                    >
                                      {stud.node.tag.length !== 0
                                        ? stud.node.tag.map(tg => (
                                            <li
                                              className="text-white"
                                              key={tg.title}
                                            >
                                              {tg.title}
                                              <span>, </span>
                                            </li>
                                          ))
                                        : null}
                                    </ul>
                                  </div>
                                </Link>
                              </div>
                            </div>
                          </Col>
                        )
                      })}
                </Row>
              </div>
            </Container>
          </section>
          <section
            className="bg-case-study slogan-section"
            style={{
              paddingTop: "5rem",
              paddingBottom: "5rem",
              zIndex: 2,
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-10 mx-auto text-center">
                  <div>
                    <h2 className="text-white">
                      Our 4-Point Innovation Roadmap Saves Firms Up to 30% on
                      Operations and Tech Costs
                    </h2>

                    <Link
                      to="/contact/"
                      className="btn btn-primary btn-arrow mr-2 mt-4 text-center py-3 text-uppercase"
                      style={{ marginTop: "auto" }}
                    >
                      Let's Chat
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </Layout>
    )
  }
}

export default CaseStudies

export const casestudy = graphql`
  query Studies {
    allSanityCaseStudy(sort: { fields: [publishedAt], order: DESC }) {
      edges {
        node {
          id
          title
          publishedAt(formatString: "L")
          categories {
            title
          }
          tag {
            title
          }
          mainImage {
            asset {
              gatsbyImageData(
                placeholder: BLURRED
                sizes: ""
                layout: CONSTRAINED
                width: 900
              )
            }
          }
          bannerImage {
            asset {
              gatsbyImageData(
                placeholder: BLURRED
                sizes: ""
                layout: CONSTRAINED
                width: 900
              )
            }
          }
          challenge
          solution
          logoImage {
            asset {
              gatsbyImageData(
                placeholder: BLURRED
                sizes: ""
                layout: CONSTRAINED
                width: 900
              )
            }
          }
          discription
          slug {
            current
          }
        }
      }
      group(field: categories___title) {
        fieldValue
        edges {
          node {
            id
            title
            categories {
              title
            }
            tag {
              title
            }
            mainImage {
              asset {
                gatsbyImageData(
                  placeholder: BLURRED
                  sizes: ""
                  layout: CONSTRAINED
                  width: 900
                )
              }
            }
            slug {
              current
            }
            discription
          }
        }
      }
    }
  }
`
